var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-headful',{attrs:{"title":`Write for me!`,"description":`Thread list`}}),_c('v-row',[_c('v-col',[_c('p',{staticClass:"display-1"},[_vm._v(" Thread List ")])])],1),_c('v-row',[_c('v-col',_vm._l((_vm.threadList),function(thread){return _c('div',{key:thread._id},[_c('thread-teaser',{attrs:{"my-thread":thread}})],1)}),0)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }